import {
  paths,
  pickerTokenResponseSchema,
  type PickerTokenResponse,
} from "@go-novus/admin-api";

import {
  requestBackendResult,
  type BackendFailure,
} from "#/shared/lib/backend-api";
import type { ResultAsync } from "#/shared/lib/result";

/**
 * 为一条已保存的元素可见规则请求店面拾取令牌。响应里的 url 直接新标签打开，
 * 商家在店面上自行导航到目标页面完成拾取。
 */
export const createPickerTokenOperation = "settings.picker_token";

export type CreatePickerTokenOperation = typeof createPickerTokenOperation;

export type CreatePickerTokenFailure =
  BackendFailure<CreatePickerTokenOperation>;

export function createPickerToken(
  ruleId: string,
  options: { fetch?: typeof globalThis.fetch; signal?: AbortSignal } = {},
): ResultAsync<PickerTokenResponse, CreatePickerTokenFailure> {
  return requestBackendResult({
    body: { ruleId },
    fetch: options.fetch,
    method: "POST",
    operation: createPickerTokenOperation,
    parse: (payload) => pickerTokenResponseSchema.parse(payload),
    path: paths.settingsPickerToken,
    signal: options.signal,
  });
}
